import script from "./Mail.vue?vue&type=script&setup=true&lang=js"
export * from "./Mail.vue?vue&type=script&setup=true&lang=js"

import "./Mail.vue?vue&type=style&index=0&id=72dd504c&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72dd504c"]])

export default __exports__